export default __webpack_public_path__ + "static/media/3497.6770d5f9.svg";